import React, { useState } from 'react';
import { AppBar, Toolbar, InputBase, makeStyles } from '@material-ui/core';
import { IconButton, TextField, Button, Paper, CircularProgress } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Typography } from '@mui/material';
import { RatingComponent } from 'react-rating-emoji'
import 'react-rating-emoji/dist/index.css'



const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    appBar: {
        backgroundColor: 'blue',
        boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.2)',
    },
    inputRoot: {
        color: 'inherit',
    },
    searchInput: {
        padding: '10px',
        borderRadius: '20px',
        backgroundColor: '#FFF',
        marginRight: theme.spacing(1),
        width: '100%',
        color: 'black'
    },
}));

const UserRatingScreen = ({ progressID, onBack }) => {
    const classes = useStyles();
    const [rating, setRating] = useState(5);
    const [review, setReview] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleRating = (newRating) => {
        setRating(newRating);
    }

    const handleReviewChange = (e) => {
        setReview(e.target.value);
    };

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`https://beiguru.co.in/api/course/${progressID}/review`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token') || '',
                },
                body: JSON.stringify({
                    review: review,
                    rating: rating,
                }),
            });

            if (response.ok) {
                onBack(true);
            } else {
                alert('There was some issue submitting review, please try again!');
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            alert('There was some issue submitting review, please try again!');
        }
    };

    return (
        <div style={{ backgroundColor: '#F6F6F6', height: '100vh' }}>
            <AppBar position="static" className={classes.appBar}>
                <Toolbar>
                    <Toolbar>
                        <div color="inherit" style={{ cursor: 'pointer', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { onBack(false); }}>
                            <ArrowBackIosIcon />
                        </div>
                        <Typography variant="h6" style={{ flexGrow: 1, fontFamily: 'Noto Sans', fontSize: '22px' }}>
                            Rating and Review
                        </Typography>
                    </Toolbar>
                </Toolbar>
            </AppBar>
            <div style={{ padding: '16px', width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ fontFamily: 'Noto Sans', fontSize: '18px', textAlign: 'center', marginBottom: '20px' }}>
                    How much would you rate our course?
                </div>
                <RatingComponent rating={rating} onClick={handleRating} />
                <div style={{ marginTop: '40px', width: '40%' }}>

                    <Paper variant="outlined"
                        sx={{
                            borderRadius: '20px',
                            border: '1.5px solid #C4C4C4',
                            backgroundColor: '#FFFFFF',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '20px',
                                '& fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'transparent',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'transparent',
                                },
                            },
                        }}>
                        <TextField
                            fullWidth
                            multiline
                            rows={5}
                            variant="outlined"
                            placeholder="Write your review here..."
                            value={review}
                            onChange={handleReviewChange}
                            InputProps={{
                                style: { fontFamily: 'Noto Sans', fontSize: '18px' },
                            }}
                        />
                    </Paper>
                </div>
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        sx={{
                            borderRadius: '20px',
                            height: '50px',
                            width: '100%',
                            padding: '10px',
                            backgroundColor: 'blue',
                            color: 'white',
                            fontFamily: 'Noto Sans', fontSize: '18px',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: '#574dcf',
                            },
                        }}>
                        {isLoading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            'Submit Review'
                        )}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default UserRatingScreen;